import { render } from "./ErrorMsg.vue?vue&type=template&id=b70faf94"
import script from "./ErrorMsg.vue?vue&type=script&lang=js"
export * from "./ErrorMsg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__